import { useBlockNumber, useBlock } from "wagmi";
import { BlockTimeGenerationResult } from "../interfaces/block";

const useBlockTime = () => {
  const { data: currentBlockNumber } = useBlockNumber();
  const { data: currentBlockData } = useBlock({
    blockNumber: currentBlockNumber,
  });

  const calculateBlockTimeGeneration =
    (): Promise<BlockTimeGenerationResult | null> | null => {
      if (!currentBlockNumber) return null;
      return new Promise((resolve) => {
        try {
          resolve({
            currentBlock: Number(currentBlockNumber),
            currentBlockTimestamp: currentBlockData?.timestamp ?? null,
          });
        } catch (e) {
          console.log("Err: calculateBlockTimeGeneration", e);
          resolve({
            currentBlock: null,
            currentBlockTimestamp: null,
          });
        }
      });
    };
  return { calculateBlockTimeGeneration };
};

export default useBlockTime;
